<template>
  <div class="table" :style="`height:${tableHeight-pageHeight}px`">
    <Loading part></Loading>
    <div class="table__contain">
      <div class="table_head" ref="table_head">
        <table>
          <colgroup>
            <col v-for="(item,index) in column" :key="index" :width="item.width" />
          </colgroup>
          <thead>
            <tr>
              <th
                :class="th.align=='center'?'text_center':''"
                v-for="(th,index) in column"
                :key="index"
              >
                {{th.name}}
                <span class="sort" @click="sortAction(th)">
                  <i class="el-icon-caret-bottom" v-if="sortAttr"></i>
                  <i class="el-icon-caret-top" v-else></i>
                </span>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table_body" ref="table_body" @scroll="bodyScroll" :style="tableBodyHeight">
        <table>
          <colgroup>
            <col v-for="(item,index) in column" :key="index" :width="item.width" />
          </colgroup>
          <tbody>
            <tr v-for="(item,index) in data" :key="index" ref="tdHeight">
              <template v-for="(th,i) in column">
                <td
                  :class="th.align=='center'?'text_center':''"
                  v-if="typeof item[th.val]==='boolean'"
                  :key="th.id"
                >
                  <i class="el-icon-success green text_center" v-if="item[th.val]"></i>
                  <i class="el-icon-error red text_center" v-else></i>
                </td>
                <td
                  :class="th.align=='center'?'text_center':''"
                  v-else-if="th.val=='action'"
                  :key="i+10"
                >
                  <!--判斷table類型-->
                  <!--工安的承攬商管理列表-->
                  <template v-if="type.includes('admin')">
                    <i class="el-icon-more icon_click"></i>
                  </template>
                  <template v-else-if="type=='contractor-employee'">
                    <!-- 判斷身份 -->
                    <template v-if="role=='manager'">
                      <i class="el-icon-more icon_click"></i>
                    </template>
                    <template v-else>
                      <i class="el-icon-edit-outline icon_click" @click="checkEmployee(item)"></i>
                    </template>
                  </template>
                </td>
                <td
                  :class="th.align=='center'?'text_center':''"
                  v-else-if="th.val=='score'"
                  :key="i+11"
                >
                  <div
                    :class="['employee_test_list',paper.paper?'employee_test_list_pass':'']"
                    v-for="(paper,index) in item[th.val]"
                    :key="index"
                    @click="employeePaperGo(paper)"
                  >{{paper.course_name}}</div>
                </td>
                <td  :class="th.align=='center'?'text_center':''" v-else-if="th.val=='department'" :key="i">
                  <template v-for="(department,index) in item[th.val]">
                    {{department.department}}<span :key='index' v-if="index!==item[th.val].length-1">、</span>
                  </template>
                </td>
                <td :class="th.align=='center'?'text_center':''" v-else :key="i">{{item[th.val]}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table_row_fixed" ref="table_row_fixed" :style="tableRowFixHeight">
        <table :class="number==1?'fixd_head':''" v-for="number in 2" :key="number">
          <colgroup>
            <template v-for="(item,index) in column">
              <col v-if="fixedColumn.includes(item.val)" :key="index" :width="item.width" />
            </template>
          </colgroup>
          <thead>
            <tr>
              <template v-for="(th,index) in column">
                <th v-if="fixedColumn.includes(th.val)" :key="index">
                  {{th.name}}
                  <span class="sort" @click="sortAction(th)">
                    <i class="el-icon-caret-bottom" v-if="sortAttr"></i>
                    <i class="el-icon-caret-top" v-else></i>
                  </span>
                </th>
              </template>
            </tr>
          </thead>
        </table>
        <table>
          <colgroup>
            <template v-for="(item,index) in column">
              <col v-if="fixedColumn.includes(item.val)" :key="index" :width="item.width" />
            </template>
          </colgroup>
          <tbody>
            <tr v-for="(item,index) in sortData" :key="index" :height="fixdColumnHeight[index]">
              <template v-for="th in column">
                <td
                  v-if="fixedColumn.includes(th.val)"
                  :key="th.id"
                  :class="th.align=='center'?'text_center':''"
                >
                  <template v-if="th.val=='action'">
                    <!--判斷table類型-->
                    <!--工安的承攬商管理列表-->
                    <template v-if="type.includes('admin')">
                      <i class="el-icon-more icon_click" @click="checkContractor(item,index)"></i>
                      <MyTransition :myName="'left'">
                        <div class="table_menu" v-if="tableMenu.index==index" :style="actionTop">
                          <ul v-if="type=='admin-contractor'">
                            <!-- 承攬商 -->
                            <li @click="ContractorData(item,index)">公司資料</li>
                            <li @click="ContractorEmployee(item,index)">員工列表</li>
                            <li  v-if="role=='manager'" @click="departmentMamagement(item,index)">需求單位管理</li>
                          </ul>
                          <ul v-else-if="type=='admin-construction'">
                            <!-- 施工單 -->
                            <li @click="constructionDel(item,index)">刪除</li>
                            <li @click="constructionedit(item,index)">編輯</li>
                          </ul>
                          <ul v-else>
                            <li @click="ContractorData(item,index)">公司資料</li>
                            <li @click="vendorCheck(item,index)">審核通過</li>
                            <li @click="vendorCancel(item,index)">審核不通過</li>
                          </ul>
                        </div>
                      </MyTransition>
                    </template>
                    <template v-else-if="type=='contractor-employee'">
                      <!-- 判斷身份 -->
                      <template v-if="role=='manager'">
                        <i class="el-icon-more icon_click" @click="checkContractor(item,index)"></i>
                        <MyTransition :myName="'left'">
                          <div  class="table_menu" v-show="tableMenu.index==index" :style="item.code_result?'top:-45px':'top:00px'">
                            <ul>
                              <template v-if="item.code_result && role=='manager'">
                                <li @click="CreateCode(item,index)" v-if="!item.code">核發合格證</li>
                                <li @click="printCode(item,index)" v-else>列印合格證</li>
                                <li @click="CardStatue(item,index)">領證</li>
                                <li @click="cancleCard(item,index)">取消領證</li>
                              </template>
                              <li @click="employeeDetail(item,index)">員工資料</li>
                              <li @click="employeeDelete(item)">刪除員工</li>
                              <template v-for="paper in item.score">
                                <li v-if="paper.paper && role=='manager'" @click="delPaper(paper,index)">刪除{{paper.course_name}}考卷</li>
                              </template>
                            </ul>
                          </div>
                        </MyTransition>
                      </template>
                      <div class="flex action_box" v-else>
                        <i class="el-icon-edit-outline icon_click" @click="checkEmployee(item)"></i>
                        <i class="el-icon-delete icon_click" @click="employeeDelete(item)"></i>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="typeof item[th.val]==='number'">
                    <i class="el-icon-success green" v-if="item[th.val]===2"></i>
                    <i class="el-icon-warning yellow" v-else-if="item[th.val]===1"></i>
                    <i class="el-icon-error red" v-else-if="item[th.val]===0"></i>
                    <i v-else>{{item[th.val]}}</i>
                  </template>
                  <template v-else>{{item[th.val]}} </template>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.table {
  position: relative;
  width: 100%;
  overflow: hidden;
  &__contain {
    //share
    table {
      font-size: 14px;
      text-align: left;
      table-layout: fixed;
      width: 100%;
      thead {
        font-weight: bold;
        background: #fff;
        .sort {
          cursor: pointer;
          font-size: 12px;
        }
      }
      td,
      th {
        position: relative;
        padding: 20px 10px;
        border-bottom: 1px solid #e1e3ee;
      }
      th {
        white-space: nowrap;
      }
      td {
        white-space: pre-wrap;
      }
      .text_center {
        text-align: center;
      }
    }
    .table_head {
      position: relative;
      // top: 0px;
      // left: 0px;
      z-index: 1;
      width: 100%;
      overflow: hidden;
    }
    .table_body {
      position: relative;
      overflow: auto;
      /*====捲軸======*/
      &::-webkit-scrollbar {
        width: 5px;
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 50px;
      }
      &::-webkit-scrollbar-track-piece {
        background: #f3f3f3;
      }
      &:hover {
        &::-webkit-scrollbar-thumb {
          background: var(--lightMainColor);
        }
      }
    }
    .table_row_fixed {
      position: absolute;
      z-index: 2;
      top: 0px;
      left: 0px;
      width: -moz-max-content;
      width: max-content;
      background: #fff;
      overflow: hidden;
      box-shadow: 10px 0 20px -15px rgba($color: #000000, $alpha: 0.5);
      table {
        width: -moz-max-content;
        width: max-content;
        &.fixd_head {
          background: #fff;
          position: fixed;
          z-index: 99;
        }
      }
    }
  }
}
.table_menu {
  left: 50px;
  width: 120px;
  text-align: center;
  position: absolute;
  z-index: 999;
  background: var(--mainColor2);
  border-radius: 5px;
  padding: 5px 0;
  color: #fff;
  box-shadow: 7px 7px 20px -10px rgba($color: #000000, $alpha: 0.5);
  ul {
    li {
      padding: 5px 10px;
      cursor: pointer;
      border-top: 1px solid #cdbaff;
      &:hover {
        font-weight: bold;
        background: #cdbaff;
        color: #fff;
      }
      &:first-child {
        border-top: none;
      }
    }
  }
}
.action_box{
  >i{
    margin:0 3px;
  }
}
.employee_test_list {
  cursor: pointer;
  margin: 3px 0;
  background: var(--fontGray);
  color: #fff;
  padding: 4px;
  text-align: center;
  border-radius: 3px;
  font-size: 13px;
  &_pass {
    background: var(--green);
    &:hover {
      background: var(--deepGreen);
    }
  }
}

.icon_click {
  cursor: pointer;
  &:hover {
    color: var(--mainColor);
    transform: scale(1.1);
  }
}
</style>
<script>
export default {
  name: "table_component",
  props: {
    data: "",
    column: Array,
    tableHeight: Number,
    pageHeight: Number,
    fixedColumn: Array,
    type: String
  },
  data() {
    return {
      theadHeight: null,
      tableMenu: {
        index: null
      },
      sortAttr: null,
      //分頁按鈕的高度
      pageOfferHeigh: 50,
      fixdColumnHeight: [],
      tdList: [],
      fixdColumnHeight_Stach: [],
      change: true,
    };
  },
  computed: {
    tableBodyHeight() {
      return `height:${this.tableHeight -
        this.theadHeight -
        this.pageOfferHeigh}px`;
    },
    tableRowFixHeight() {
      return `height:${this.tableHeight - this.pageOfferHeigh - 10}px`;
      //10為落差
    },
    role() {
      return this.$store.state.user.role;
    },
    sortData() {
      if (
        this.type == "admin-contractor" ||
        this.type == "admin-construction"
      ) {
        return this.data;
      } else {
        if (this.sortAttr == null) {
          return this.data;
        } else if (this.sortAttr.includes("sort")) {
          //正排
          const item = this.sortAttr.split("_sort")[0];
          return this.data.sort((a, b) => {
            //另外處理字串的排序
            if (typeof a[item] == "string") {
              //如果是字串的數字
              if (a[item].match(/^[0-9]*$/)) {
                return a[item] - b[item];
              } else {
                //如果A大於B，則回傳1，由小到大
                //如果A小於B，則回傳-1，由大到小
                return a[item] > b[item] ? 1 : -1;
              }
            } else {
              return a[item] > b[item] ? 1 : -1;
            }
          });
        } else {
          //逆排
          const item = this.sortAttr;
          return this.data.sort((a, b) => {
            if (typeof a[item] == "string") {
              if (a[item].match(/^[0-9]*$/)) {
                return b[item] - a[item];
              } else {
                return a[item] < b[item] ? 1 : -1;
              }
            } else {
              return a[item] < b[item] ? 1 : -1;
            }
          });
        }
      }
    },
    actionTop() {
      switch (this.type) {
        case "admin-contractor":
        case "admin-construction":
          return "top:-5px";
          break;
        default:
          return "top:-30px";
      }
    },
    storage() {
      return this.$http.base.storage;
    }
  },
  methods: {
    bodyScroll(val) {
      this.$refs.table_head.scrollLeft = val.target.scrollLeft;
      this.$refs.table_row_fixed.scrollTop = val.target.scrollTop;
    },
    checkContractor(item, index) {
      this.tableMenu.index === index
        ? (this.tableMenu.index = null)
        : (this.tableMenu.index = index);
    },
    checkEmployee(item) {
      if(this.role=='department'){
        this.$router.push({
          name:"department_contractor_employee_detail",
          query: {
            employee_id: item.employee_id
          }
        });        
      }else{
        this.$router.push({
          path: `/${this.$route.path.split("/")[1]}/addemployee`,
          query: {
            employee_id: item.employee_id
          }
        });
      }

    },
    ContractorData(item, index) {
      if(this.role=="manager"){
      this.$router.push({
        name: "contractor_data",
        query: {
          vendorId: item.vendor_id
        }
      });
      }else{
      this.$router.push({
        name: "department_contractor_data",
        query: {
          vendorId: item.vendor_id
        }
      });        
      }

    },
    ContractorEmployee(item, index) {
      if(this.role == "manager"){
      this.$router.push({
        name: "contractor_employee",
        query: {
          vendorId: item.vendor_id,
          name: item.vendor_chinese
        }
      });
      }else{
      this.$router.push({
        name: "department_contractor_employee",
        query: {
          vendorId: item.vendor_id,
          name: item.vendor_chinese
        }
      });        
      }

    },
    CreateCode(item, index) {
      this.$emit("create", item);
    },
    printCode(item, index) {
      this.tableMenu.index = null;
      const href = this.$router.resolve({
        name: "card",
        query: {
          employee: item.employee_id,
          code: item.code
        }
      });
      window.open(href.href, "_blank");
    },
    employeeDetail(item, index) {
      if (this.role == "manager") {
        this.$router.push({
          name: "contractor_employee_detail",
          query: {
            vendorId: this.vendorId,
            employee_id: item.employee_id
          },
          params: {
            userData: item
          }
        });
      }
      else{
        this.$router.push({
          name: "department_contractor_employee_detail",
          query: {
            vendorId: this.vendorId,
            employee_id: item.employee_id
          },
          params: {
            userData: item
          }
        });        
      }
    },
    delPaper(item,index){
      this.$emit("delPaper", item);


    },
    vendorCheck(item, index) {
      this.$emit("check", item);
    },
    vendorCancel(item, index) {
      this.$emit("cancel", item);
    },
    constructionDel(item, index) {
      this.$emit("del", item);
    },
    constructionedit(item, index) {
      this.$emit("edit", item);
    },
    sortAction(th) {
      this.sortAttr == th.val
        ? (this.sortAttr = `${th.val}_sort`)
        : (this.sortAttr = th.val);
      if (
        this.type == "admin-contractor" ||
        this.type == "admin-construction"
      ) {
        this.$emit("sort", this.sortAttr);
      }
      this.change = true;
    },
    columnHeightAction(list) {
      this.change = false;
      this.fixdColumnHeight = list;
    },
    CardStatue(item, index) {
      this.$emit("receive", item);
    },
    cancleCard(item, index){
      this.$emit("cancleCard", item);
    },
    employeeDelete(item){
      this.$emit("employeeDelete", item);
    },
    employeePaperGo(item) {
      if (item.paper) {
        const num =Math.floor(Math.random()*10)
        window.open(`${this.storage}${item.paper}?v=${num}`, "_blank");
      }
    },
    departmentMamagement(item,index){
      this.$router.push({
          name: "contractor_department",
          query: {
            vendorId: item.vendor_id,
          },
          params:{
            data:item
          }

        });    

    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit("loadingEnd");
    });
    
    this.theadHeight = this.$refs.table_head.offsetHeight;
  },
  updated() {
    if (this.$refs.tdHeight) {
      this.tdList = this.$refs.tdHeight;
      const list = [];
      this.tdList.forEach((el, index) => {
        list.push(el.offsetHeight);
      });
      this.fixdColumnHeight_Stach = list;
      if (this.change) {
        this.columnHeightAction(list);
      }
    }
  }
};
</script>
